import React, { FC } from 'react'
import HideSource from '@mui/icons-material/HideSource'
import NewLayout from './components/NewLayout'

const SiteVisitDeclined: FC = () => {
  return (
    <NewLayout.Outer>
      <NewLayout.Inner size="xl">
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-6">
          <div className="tw:rounded-full tw:p-6 tw:bg-neutrals-100">
            <HideSource className="tw:!size-12" />
          </div>
          <div className="tw:flex tw:flex-col tw:items-center">
            <p className="tw:text-lg tw:text-center">{'Project declined'}</p>
            <p className="tw:text-tertiary-black tw:text-center">
              {'We appreciate your input and hope to collaborate in the future.'}
            </p>
          </div>
        </div>
      </NewLayout.Inner>
    </NewLayout.Outer>
  )
}

export default SiteVisitDeclined
